import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs'
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionData} from '../oe-proto-model';

export const OEEquineHoofTargetType = {
    anatomy:        'anatomy',
    dynamic:        'dynamic'
};

OEEquineHoofTargetType.all = [
    OEEquineHoofTargetType.anatomy,
    OEEquineHoofTargetType.dynamic
];

export const OEEquineHoofTargets = new OEVersionTargets(
    {
        [OEEquineHoofTargetType.anatomy]: [
            OETarget.hoofCarpal,
            OETarget.hoofMicro
        ],
        [OEEquineHoofTargetType.dynamic]: [
            OETarget.hoofDynamics
        ]
    },
    {
        [OEEquineHoofTargetType.anatomy]: OETarget.hoofCarpal
    },
    {
        [OEEquineHoofTargetType.anatomy]: OETarget.hoofCarpal
    }
);

export const OEEquineHoofFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
            dynamicTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
                featureAccess.dynamicTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEEquineHoofTargets);

export const OEEquineHoofStartSelectionData = new OEVersionStartSelectionData(
    OEEquineHoofTargets,
    undefined,
    {
        [OEEquineHoofTargetType.anatomy]: [
            OETargetMenuDefs.hoofCarpal,
            OETargetMenuDefs.hoofMicro
        ],
        [OEEquineHoofTargetType.dynamic]: [OETargetMenuDefs.hoofDynamics]
    }
);